/**
 * Copy from Angular code. On src attributes, modern browsers run JavaScript code only
 * when the URL starts with `javascript:` protocol, which this Regex catches.
 * @see https://github.com/angular/angular/blob/main/packages/core/src/sanitization/url_sanitizer.ts
 */

// biome-ignore lint/style/useNamingConvention: original repo style
const SAFE_URL_PATTERN: RegExp = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:\/?#]*(?:[\/?#]|$))/i;
function sanitize(url: unknown): unknown {
  if (!url) {
    return '';
  }
  const testUrl: string = String(url);
  if (testUrl.match(SAFE_URL_PATTERN)) {
    return url;
  }
  console.warn(`WARNING: sanitizing unsafe URL value ${url}.`);
  return 'unsafe';
}

export function urlSanitizer(node: Node, name: string, type: 'property' | 'attribute'): (value: unknown) => unknown {
  /*
   * Needed only when used as source attribute: 'href' or 'src'
   * Also needed for `hrefLink` from BcfRouterHrefLinkElement
   * */
  if (['property', 'attribute'].includes(type) && ['src', 'href', 'hrefLink'].includes(name)) {
    return sanitize;
  }

  // For all other cases return the identity function
  return (value: unknown) => value;
}
